export const defaultStyles = {
  elevation: 0
}
